import { QueryOptions } from '@apollo/client';
import { gql } from '__generated__';
import { QueryCompanyPackagesArgs } from '__generated__/graphql';
import {
  HIGHLIGHTED_PACKAGES,
  SOCIAL_NETWORK_PACKAGES,
  TOP_RESULT_PACKAGES,
} from 'containers/JobSubmissionPage/graphql';
import client from 'graphql/client';

const fetchPackagesGraphql = (payload: {
  recache?: boolean;
  variables?: QueryCompanyPackagesArgs;
}) => {
  const params: Omit<QueryOptions, 'query' | 'variables'> = {};
  const { recache, variables } = payload;

  if (recache) {
    params.fetchPolicy = 'network-only';
  }
  const query = gql(`
    query packages($includePending: Boolean) {
      companyPackages(includePending: $includePending) {
        id
        activationDate
        expirationDate
        balance
        initialBalance
        jobPackageType
        jobType
        packageDuration
        companyName
        combo
        status
        isExternalLinkFree
      }
    }
  `);

  return client.query({
    query,
    variables,
    ...params,
  });
};

export const fetchSocialPostingPackagesQuery = () => {
  return client.query({
    query: SOCIAL_NETWORK_PACKAGES,
    fetchPolicy: 'network-only',
  });
};

export const fetchHighlightedPackagesQuery = () => {
  return client.query({
    query: HIGHLIGHTED_PACKAGES,
    fetchPolicy: 'network-only',
  });
};

export const fetchTopResultPackagesQuery = () => {
  return client.query({
    query: TOP_RESULT_PACKAGES,
    fetchPolicy: 'network-only',
  });
};

export default fetchPackagesGraphql;
